export function isNumericInteger(str: string): boolean {
  if (!str.trim()) return false

  const num = Number(str)

  return !isNaN(num) && Number.isInteger(num)
}
